webpackJsonp([277149362338250],{

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Adrian-Mouat.97fd6f36.jpg";

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AdrianMouat = __webpack_require__(115);
	
	var _AdrianMouat2 = _interopRequireDefault(_AdrianMouat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AdrianMouat = function AdrianMouat() {
	  return _react2.default.createElement(
	    'section',
	    { id: 'speaker', className: 'parallax-section' },
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-12 col-sm-12 wow fadeInUp', 'data-wow-delay': '0.1s' },
	          _react2.default.createElement(
	            'div',
	            { className: 'team-wrapper' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              'Adrian Mouat'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6' },
	                _react2.default.createElement('img', { src: _AdrianMouat2.default, className: 'img-responsive', alt: 'Adrian Mouat' }),
	                _react2.default.createElement(
	                  'ul',
	                  { className: 'social-icon' },
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement('a', { href: 'https://www.linkedin.com/in/adrianmouat/', target: '_blank', className: 'fa fa-linkedin wow fadeIn' })
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement('a', { href: 'https://twitter.com/adrianmouat', target: '_blank', className: 'fa fa-twitter wow fadeIn' })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-5' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Adrian Mouat is Chief Scientist at Container Solutions, a cloud-native consultancy and Kubernetes Certified Service Provider. Adrian is a member of the Docker Captains program and the author of "Using Docker", published by O\u2019Reilly Media.',
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement('br', null),
	                  'He is currently researching image management and distribution on clusters. As part of this research, he has released ImageWolf, a PoC that uses bittorrent to distribute images across a Kubernetes cluster and Trow, a cluster-first image registry.'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'h4',
	                null,
	                'Talk: Establishing Image Provenance and Security in Kubernetes'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Take any container running in your Kubernetes cluster. What can you say about it and with what level of certainty? Do you know where it came from? Could an attacker have modified it? Is it up-to-date? Can you identify the exact revision of the code that the image was built from? ',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                'This talk will look at what guarantees Kubernetes gives you out-of-the-box, and what you can do to establish a trustworthy and reliable workflow for deploying and updating images. Topics and tooling covered will include: - building images in a repeatable manner with BuildKit or Bazel - distributing images through registries - verifying provenance with secure hashes as well as Notary/TUF'
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = AdrianMouat;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-speakers-adrian-mouat-js-dc6fe2b1529ec12469e7.js